import {useTopBeers} from 'hooks/useTopBeers';
import TopBeers from 'pages/dashboard/TopBeers/TopBeers';

const TopItemsBeers = () => {
  const [topBeers, beersIncluded, isLoading] = useTopBeers();

  if (isLoading) {
    return (
      <div className="manager-page__loader">
        <div className="spinner-border" role="status" />
      </div>
    );
  }

  return <TopBeers topBeers={topBeers} beersIncluded={beersIncluded} />;
};

export default TopItemsBeers;
